import StoreFactory from "@/store";

export default StoreFactory();
